import { render } from "./HydwHeadline.vue?vue&type=template&id=7534ed62&scoped=true&ts=true"
import script from "./HydwHeadline.vue?vue&type=script&lang=ts"
export * from "./HydwHeadline.vue?vue&type=script&lang=ts"

import "./HydwHeadline.vue?vue&type=style&index=0&id=7534ed62&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7534ed62"]])

export default __exports__